import { render, staticRenderFns } from "./BasePuzzle.vue?vue&type=template&id=01c83504&"
import script from "./BasePuzzle.vue?vue&type=script&lang=js&"
export * from "./BasePuzzle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports